"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const md_1 = require("react-icons/md");
const fa_1 = require("react-icons/fa");
const AddOrUpdateFaqModal_1 = __importDefault(require("../modals/AddOrUpdateFaqModal"));
const faq_api_1 = require("../../../../utils/api/faq/faq.api");
const UseCrudFaq_1 = require("../requestForm/UseCrudFaq");
const ai_1 = require("react-icons/ai");
const ViewFaqModal_1 = __importDefault(require("../modals/ViewFaqModal"));
const Utils_1 = require("../../../../utils/Utils");
const UpdateFaqButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-edit", "data-tooltip-content": "Modifier", onClick: handleShow },
            react_1.default.createElement(md_1.MdEdit, { className: "edit-action-icon" })),
        react_1.default.createElement(AddOrUpdateFaqModal_1.default, { show: show, handleClose: handleClose, item: item })));
};
const DeleteFaqButton = ({ id }) => {
    const onDelete = (0, UseCrudFaq_1.UseDeleteFaq)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const ViewFaqButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", onClick: handleShow },
            react_1.default.createElement(ai_1.AiFillEye, null)),
        react_1.default.createElement(ViewFaqModal_1.default, { show: show, handleClose: handleClose, item: item })));
};
const FaqAdminTable = ({ search }) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, faq_api_1.useGetFaqsQuery)({});
    const formattedData = (0, react_1.useMemo)(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : []; }, [data]);
    const filteredData = (0, react_1.useMemo)(() => {
        return formattedData.filter((item) => {
            var _a, _b;
            const q = `${(_a = item === null || item === void 0 ? void 0 : item.question) !== null && _a !== void 0 ? _a : ""} ${(_b = item === null || item === void 0 ? void 0 : item.reponse) !== null && _b !== void 0 ? _b : ""}`.toLowerCase();
            return q.includes(search.toLowerCase());
        });
    }, [formattedData, search]);
    const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement(ViewFaqButton, { item: row }),
            react_1.default.createElement(UpdateFaqButton, { item: row }),
            react_1.default.createElement(DeleteFaqButton, { id: row.id })));
    };
    const reponseFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "m-0", dangerouslySetInnerHTML: (0, Utils_1.createMarkup)((0, Utils_1.truncateString)(row === null || row === void 0 ? void 0 : row.reponse, 200)) })));
    };
    const columns = [
        {
            dataField: "question",
            text: "Question",
            headerStyle: () => ({ width: "35%", whiteSpace: "normal", textAlign: "start" }),
        },
        {
            dataField: "reponse",
            text: "Réponse",
            formatter: reponseFormatter,
            headerStyle: () => ({ width: "50%", whiteSpace: "normal", textAlign: "start" }),
        },
        {
            dataField: "ordre",
            text: "Ordre",
            headerStyle: () => ({ width: "10%", whiteSpace: "normal", textAlign: "start" }),
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => ({ width: "150px", whiteSpace: "normal", textAlign: "start" }),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (p, pp) => {
                                setPerPage(pp);
                                setPage(p);
                            }, perPage: perPage }))))))));
};
exports.default = FaqAdminTable;
